import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../../../store";
import { setErrors } from "../../../../store/alerts/alertsActions";
import { useConfirm } from "material-ui-confirm";
import { useNavigate } from "react-router";
import { FINALIZE_PAGE } from "../../../../routes";

const DEFAULT_TITLE = "Wybierz miejsca";

export default function useCinemaHallButtons(
  activeStep: number,
  setActiveStep: Function,
  totalBasket: number,
  validateBasket: Function,
  onClearBasket: Function
) {
  const [isVisible, setIsVisible] = useState(false);
  const [title, setTitle] = useState(DEFAULT_TITLE);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const confirm = useConfirm();
  const selectedSeats = useSelector((state: State) => state.basket.selectedSeats);
  const disabledSelectTicket = selectedSeats.length === 0;

  const getTitle = () => {
    if (selectedSeats.length === 1) {
      setTitle("Wybrano 1 miejsce");
    } else if (selectedSeats.length < 5) {
      setTitle(`Wybrano ${selectedSeats.length} miejsca`);
    } else {
      setTitle(`Wybrano ${selectedSeats.length} miejsc`);
    }
  };

  useEffect(() => {
    if (disabledSelectTicket) {
      setIsVisible(false);
      setTitle(DEFAULT_TITLE);
    } else {
      setIsVisible(true);
      setTitle(`Wybrano ${selectedSeats.length} miejsc`);
    }
    //eslint-disable-next-line
  }, [disabledSelectTicket]);

  useEffect(() => {
    if (!disabledSelectTicket && activeStep === 0) {
      getTitle();
    }

    if (activeStep === 1) {
      if (!validateBasket()) {
        setButtonDisabled(false);
        setTitle(`Suma: ${totalBasket} zł`);
      } else {
        getTitle();
      }
    }

    //eslint-disable-next-line
  }, [selectedSeats, totalBasket, activeStep]);

  const handleGoBack = () => {
    if (activeStep === 1) {
      // confirm({
      //   title: "Czy na pewno chcesz to zrobić?",
      //   description: "Twój wybór zostanie anulowany a Ty wrócisz na stronę główną.",
      // })
      //   .then(() => {
      //     onClearBasket();
      //     setActiveStep(0);
      //     setButtonDisabled(false);
      //   })
      //   .catch(() => {});
      setActiveStep(0);
    }
  };

  const handleGoNext = () => {
    if (activeStep === 0) {
      setActiveStep(1);
      setButtonDisabled(true);
      setTitle("Wybierz bilety");
    } else if (activeStep === 1) {
      if (!validateBasket()) {
        navigate(FINALIZE_PAGE);
      } else {
        dispatch(setErrors(["Najpierw wybierz bilety"]));
      }
    }
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  return {
    isVisible,
    title,
    handleGoBack,
    handleGoNext,
    buttonDisabled,
  };
}
